// extracted by mini-css-extract-plugin
export default {"choices":"page_choices__6SNVc"};